/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacySuppliers from './pharmacy-suppliers';
import PharmacySuppliersDetail from './pharmacy-suppliers-detail';
import PharmacySuppliersUpdate from './pharmacy-suppliers-update';
import PharmacySuppliersDeleteDialog from './pharmacy-suppliers-delete-dialog';

const PharmacySuppliersRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacySuppliers />} />
    <Route path="new" element={<PharmacySuppliersUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacySuppliersDetail />} />
      <Route path="edit" element={<PharmacySuppliersUpdate />} />
      <Route path="delete" element={<PharmacySuppliersDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacySuppliersRoutes;
